import React, { useId } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Button } from '../Button';
import { SubscriptionCardV8 } from '../SubscriptionCardV8';
import { renderAgreementTerms } from '../../shared/render-agreement-terms';
import styles from './SubscriptionPlanSelectorV8.css';

const cx = classnames.bind(styles);

function SubscriptionPlanSelectorV8({ className = '', plans, onSubmit, selectedSubscriptionData, selectSubscription, isPending = false, spriteVersion, termsOfUseLink }) {
    const classes = cx({
        root: true,
        [className]: Boolean(className)
    });
    const radioGroupName = useId();

    return (
        <div className={classes}>
            <div className={styles.plans}>
                {plans.map(plan => (
                    <SubscriptionCardV8
                        subscriptionData={plan}
                        selectedSubscriptionData={selectedSubscriptionData}
                        selectSubscription={selectSubscription}
                        spriteVersion={spriteVersion}
                        name={radioGroupName}
                        key={plan.plan}
                    />
                ))}
            </div>
            {Boolean(selectedSubscriptionData.plan) && (
                <p className={styles.agreementTermsText}>
                    {renderAgreementTerms(selectedSubscriptionData, 'By clicking “Get my plan”', termsOfUseLink)}
                </p>
            )}
            <Button
                type='ink'
                label='Get my plan'
                iconRight={{ name: 'chevronRight' }}
                onClick={() => onSubmit(selectedSubscriptionData)}
                className={styles.button}
                isLoading={isPending}
                inSlide
            />
        </div>
    );
}

SubscriptionPlanSelectorV8.propTypes = {
    className: PropTypes.string,
    plans: PropTypes.array.isRequired,
    onSubmit: PropTypes.func.isRequired,
    selectedSubscriptionData: PropTypes.object.isRequired,
    selectSubscription: PropTypes.func.isRequired,
    isPending: PropTypes.bool,
    spriteVersion: PropTypes.string.isRequired,
    termsOfUseLink: PropTypes.string.isRequired
};

export {
    SubscriptionPlanSelectorV8
};
